import { render } from "./FooterBlock.vue?vue&type=template&id=7eb8e4ab&scoped=true"
const script = {}

import "./FooterBlock.vue?vue&type=style&index=0&id=7eb8e4ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb8e4ab"]])

export default __exports__